import { useState } from 'react';
import { CheckBox } from './Checkbox';
type CheckboxListProps = {
  items: string[];
  initiallySelected?: string[]; // New prop for initially selected items
  onChange?: (checkedValues: string[]) => void;
  error?: string;
};

export const CheckboxList = (props: CheckboxListProps) => {
  const { items, onChange, error, initiallySelected = [] } = props;

  const initialState = items.map((item) => initiallySelected.includes(item));
  const [checked, setChecked] = useState<boolean[]>(initialState);

  const handleToggle = (index: number) => {
    const updated = checked.map((val, i) => (i === index ? !val : val));
    setChecked(updated);
    const checkedValues = items.filter((_, i) => updated[i]);
    onChange?.(checkedValues);
  };

  return (
    <>
      <div className={'border border-gray-100 rounded-xl divide-y divide-solid divide-gray-100'}>
        {items.map((label, index) => (
          <div
            className='text-gray-700 text-md font-medium flex flex-row gap-2 h-[72px] p-4'
            key={label}
          >
            <CheckBox
              isSelected={checked[index]}
              onChange={() => handleToggle(index)}
              size='md'
              description={label}
              additionalClassnames='text-gray-700'
            />
          </div>
        ))}
      </div>
      {error && <div className='text-sm text-error-500 p-1'>{props.error}</div>}
    </>
  );
};
